import React, { useState, useEffect } from 'react';
import { useLocation } from '../context/LocationContext';
import LocationSelector from './LocationSelector';
import './LocationSelectionModal.css';

const LocationSelectionModal = ({ onLocationSet, isOpen: controlledIsOpen, onClose }) => {
  const { isLocationSet } = useLocation();
  const [internalIsOpen, setInternalIsOpen] = useState(false);

  // Use controlled isOpen if provided, otherwise use internal state
  const isVisible = controlledIsOpen !== undefined ? controlledIsOpen : internalIsOpen;

  useEffect(() => {
    // Auto-show modal if location is not set and not controlled externally
    if (controlledIsOpen === undefined && !isLocationSet) {
      setInternalIsOpen(true);
    } else if (controlledIsOpen === undefined && isLocationSet) {
      setInternalIsOpen(false);
    }
  }, [isLocationSet, controlledIsOpen]);

  const handleLocationSelected = () => {
    // Small delay to ensure location is saved
    setTimeout(() => {
      if (controlledIsOpen !== undefined && onClose) {
        onClose();
      } else {
        setInternalIsOpen(false);
      }
      if (onLocationSet) {
        onLocationSet();
      }
    }, 100);
  };

  const handleClose = () => {
    if (controlledIsOpen !== undefined && onClose) {
      onClose();
    } else {
      setInternalIsOpen(false);
    }
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="location-modal-overlay" onClick={handleClose}>
      <div className="location-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="location-modal-header">
          <div>
            <h2>{isLocationSet ? 'Change Location' : 'Welcome to MYHELPZ!'}</h2>
            <p>{isLocationSet ? 'Select a new location' : 'Please select your location to continue'}</p>
          </div>
          <button className="location-modal-close-btn" onClick={handleClose}>
            ×
          </button>
        </div>
        <div className="location-modal-body">
          <LocationSelector 
            onLocationSelected={handleLocationSelected}
            showTitle={false}
            isModal={true}
          />
        </div>
        <div className="location-modal-footer">
          <p className="location-modal-hint">
            This location will be saved and used as default for future sessions. 
            You can change it anytime by clicking the location icon.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LocationSelectionModal;

